module.exports = __webpack_public_path__ + "img/about.6eade57b.jpg";